"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oidc_client_ts_1 = require("oidc-client-ts");
class OidcCodeFlow {
    constructor($window) {
        this.$window = $window;
    }
    init(config) {
        if (this.userManager)
            return;
        this.userManager = this.createUserManager(config);
    }
    createUserManager(config) {
        return new oidc_client_ts_1.UserManager({
            authority: config.openidServerUrl,
            client_id: config.openidClientId,
            redirect_uri: this.buildRedirectUri(),
            post_logout_redirect_uri: this.buildRedirectUri(),
            response_type: "code",
            scope: config.openidScope,
            automaticSilentRenew: true,
            userStore: new oidc_client_ts_1.WebStorageStateStore({ store: this.$window.localStorage })
        });
    }
    buildRedirectUri() {
        let { protocol, host, pathname, hash } = this.$window.location;
        let currentUrl = `${protocol}//${host}${pathname}${hash}`;
        let withoutLoginRoute = currentUrl.replace("#!/login", "");
        return withoutLoginRoute.split("?")[0];
    }
    isCallback(url) {
        let query = url.split("#")[0].split("?")[1];
        if (!query)
            return false;
        let params = new URLSearchParams(query);
        if (!params.has("state"))
            return false;
        return params.has("code") || params.has("error");
    }
    login(phoneNumber) {
        return this.manager().signinRedirect({ state: { phoneNumber: phoneNumber || "" } });
    }
    handleCallback(url) {
        return this.manager().signinRedirectCallback(url).then((user) => this.toResult(user));
    }
    silentLogin() {
        return this.manager().signinSilent().then((user) => {
            if (!user)
                return Promise.reject(new Error("OidcSilentLoginFailed"));
            return this.toResult(user);
        });
    }
    hasStoredUser() {
        return this.manager().getUser().then(user => !!user);
    }
    logout(idToken) {
        return this.manager().signoutRedirect(idToken ? { id_token_hint: idToken } : {});
    }
    clearStoredState() {
        if (!this.userManager)
            return Promise.resolve();
        return this.userManager.removeUser();
    }
    toResult(user) {
        let state = user.state;
        let result = {
            accessToken: user.access_token,
            idToken: user.id_token
        };
        if (state && state.phoneNumber) {
            result.phoneNumber = state.phoneNumber;
        }
        return result;
    }
    manager() {
        if (!this.userManager)
            throw new Error("OidcCodeFlow not initialized");
        return this.userManager;
    }
}
exports.default = OidcCodeFlow;
OidcCodeFlow.$inject = ["$window"];
